// Auth-gated image loader — fetches a private image via the API with the
// stored JWT and produces an object URL that <img> can render. Used by the
// Quote Builder visuals panel (staff view) so private site photos and AI
// renders never leak to unauthenticated network sniffers.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const AuthImage = ({ quoteId, fileId, alt, className, onClick }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    let cancelled = false;
    api.get(`/quotes/${quoteId}/visual-file/${fileId}`, { responseType: "blob" })
      .then((res) => {
        if (cancelled) return;
        url = URL.createObjectURL(res.data);
        setSrc(url);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [quoteId, fileId]);
  if (!src) return <div className={`${className} bg-slate-100 animate-pulse`} />;
  return <img src={src} alt={alt || ""} className={className} onClick={onClick} />;
};

export default AuthImage;
